export default __webpack_public_path__ + "static/media/astronaut.770f592a.png";